/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetEodLogDtoDocument
 */
export interface GetEodLogDtoDocument {
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    recipientNIP: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    recipientName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    externalNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    projectNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    saleDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    receiptDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientEODId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientCity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientAddress: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientPostalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientCountry: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientCountryCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    clientNIP: string;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    vatAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    grossAmount: number;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    exchangeRate?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    exchangeRateDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    exchangeRateTable?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    paymentDueDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    paymentMethod?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    bankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    bankAccountNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isCorrectionInvoice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    correctedInvoiceNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    correctedInvoiceDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    pokId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isExported?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isDownloadedFromEOD?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isInvoiceFromPOK?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    proformaNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    proformaId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    matchesProforma?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isPaid?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    eodChangeDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof GetEodLogDtoDocument
     */
    pokChangeDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    filePath?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isTelevision: number;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isPostingChanged?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    isAccountChanged?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    cancelled?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    cancelledReason?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetEodLogDtoDocument
     */
    paidStatus?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetEodLogDtoDocument
     */
    pesel?: string | null;
}

/**
 * Check if a given object implements the GetEodLogDtoDocument interface.
 */
export function instanceOfGetEodLogDtoDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "recipientNIP" in value;
    isInstance = isInstance && "recipientName" in value;
    isInstance = isInstance && "externalNumber" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "saleDate" in value;
    isInstance = isInstance && "receiptDate" in value;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "clientAddress" in value;
    isInstance = isInstance && "clientCountry" in value;
    isInstance = isInstance && "clientCountryCode" in value;
    isInstance = isInstance && "clientNIP" in value;
    isInstance = isInstance && "netAmount" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "grossAmount" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "paymentDueDate" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "isTelevision" in value;

    return isInstance;
}

export function GetEodLogDtoDocumentFromJSON(json: any): GetEodLogDtoDocument {
    return GetEodLogDtoDocumentFromJSONTyped(json, false);
}

export function GetEodLogDtoDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEodLogDtoDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'recipientNIP': json['recipientNIP'],
        'recipientName': json['recipientName'],
        'externalNumber': json['externalNumber'],
        'referenceNumber': !exists(json, 'referenceNumber') ? undefined : json['referenceNumber'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'issueDate': (new Date(json['issueDate'])),
        'saleDate': (new Date(json['saleDate'])),
        'receiptDate': (new Date(json['receiptDate'])),
        'clientEODId': !exists(json, 'clientEODId') ? undefined : json['clientEODId'],
        'clientName': json['clientName'],
        'clientCity': !exists(json, 'clientCity') ? undefined : json['clientCity'],
        'clientAddress': json['clientAddress'],
        'clientPostalCode': !exists(json, 'clientPostalCode') ? undefined : json['clientPostalCode'],
        'clientCountry': json['clientCountry'],
        'clientCountryCode': json['clientCountryCode'],
        'clientNIP': json['clientNIP'],
        'netAmount': json['netAmount'],
        'vatAmount': json['vatAmount'],
        'grossAmount': json['grossAmount'],
        'currency': json['currency'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'exchangeRateDate': !exists(json, 'exchangeRateDate') ? undefined : (json['exchangeRateDate'] === null ? null : new Date(json['exchangeRateDate'])),
        'exchangeRateTable': !exists(json, 'exchangeRateTable') ? undefined : json['exchangeRateTable'],
        'paymentDueDate': (new Date(json['paymentDueDate'])),
        'paymentMethod': !exists(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'bankName': !exists(json, 'bankName') ? undefined : json['bankName'],
        'bankAccountNumber': !exists(json, 'bankAccountNumber') ? undefined : json['bankAccountNumber'],
        'isCorrectionInvoice': !exists(json, 'isCorrectionInvoice') ? undefined : json['isCorrectionInvoice'],
        'correctedInvoiceNumber': !exists(json, 'correctedInvoiceNumber') ? undefined : json['correctedInvoiceNumber'],
        'correctedInvoiceDate': !exists(json, 'correctedInvoiceDate') ? undefined : (json['correctedInvoiceDate'] === null ? null : new Date(json['correctedInvoiceDate'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'pokId': !exists(json, 'pokId') ? undefined : json['pokId'],
        'isExported': !exists(json, 'isExported') ? undefined : json['isExported'],
        'isDownloadedFromEOD': !exists(json, 'isDownloadedFromEOD') ? undefined : json['isDownloadedFromEOD'],
        'isInvoiceFromPOK': !exists(json, 'isInvoiceFromPOK') ? undefined : json['isInvoiceFromPOK'],
        'proformaNumber': !exists(json, 'proformaNumber') ? undefined : json['proformaNumber'],
        'proformaId': !exists(json, 'proformaId') ? undefined : json['proformaId'],
        'matchesProforma': !exists(json, 'matchesProforma') ? undefined : json['matchesProforma'],
        'isPaid': !exists(json, 'isPaid') ? undefined : json['isPaid'],
        'status': json['status'],
        'statusDescription': !exists(json, 'statusDescription') ? undefined : json['statusDescription'],
        'eodChangeDate': !exists(json, 'eodChangeDate') ? undefined : (json['eodChangeDate'] === null ? null : new Date(json['eodChangeDate'])),
        'pokChangeDate': !exists(json, 'pokChangeDate') ? undefined : (json['pokChangeDate'] === null ? null : new Date(json['pokChangeDate'])),
        'filePath': !exists(json, 'filePath') ? undefined : json['filePath'],
        'isTelevision': json['isTelevision'],
        'isPostingChanged': !exists(json, 'isPostingChanged') ? undefined : json['isPostingChanged'],
        'isAccountChanged': !exists(json, 'isAccountChanged') ? undefined : json['isAccountChanged'],
        'cancelled': !exists(json, 'cancelled') ? undefined : json['cancelled'],
        'cancelledReason': !exists(json, 'cancelledReason') ? undefined : json['cancelledReason'],
        'paidStatus': !exists(json, 'paidStatus') ? undefined : json['paidStatus'],
        'pesel': !exists(json, 'pesel') ? undefined : json['pesel'],
    };
}

export function GetEodLogDtoDocumentToJSON(value?: GetEodLogDtoDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'recipientNIP': value.recipientNIP,
        'recipientName': value.recipientName,
        'externalNumber': value.externalNumber,
        'referenceNumber': value.referenceNumber,
        'projectNumber': value.projectNumber,
        'issueDate': (value.issueDate.toISOString()),
        'saleDate': (value.saleDate.toISOString()),
        'receiptDate': (value.receiptDate.toISOString()),
        'clientEODId': value.clientEODId,
        'clientName': value.clientName,
        'clientCity': value.clientCity,
        'clientAddress': value.clientAddress,
        'clientPostalCode': value.clientPostalCode,
        'clientCountry': value.clientCountry,
        'clientCountryCode': value.clientCountryCode,
        'clientNIP': value.clientNIP,
        'netAmount': value.netAmount,
        'vatAmount': value.vatAmount,
        'grossAmount': value.grossAmount,
        'currency': value.currency,
        'exchangeRate': value.exchangeRate,
        'exchangeRateDate': value.exchangeRateDate === undefined ? undefined : (value.exchangeRateDate === null ? null : value.exchangeRateDate.toISOString()),
        'exchangeRateTable': value.exchangeRateTable,
        'paymentDueDate': (value.paymentDueDate.toISOString()),
        'paymentMethod': value.paymentMethod,
        'bankName': value.bankName,
        'bankAccountNumber': value.bankAccountNumber,
        'isCorrectionInvoice': value.isCorrectionInvoice,
        'correctedInvoiceNumber': value.correctedInvoiceNumber,
        'correctedInvoiceDate': value.correctedInvoiceDate === undefined ? undefined : (value.correctedInvoiceDate === null ? null : value.correctedInvoiceDate.toISOString()),
        'description': value.description,
        'notes': value.notes,
        'pokId': value.pokId,
        'isExported': value.isExported,
        'isDownloadedFromEOD': value.isDownloadedFromEOD,
        'isInvoiceFromPOK': value.isInvoiceFromPOK,
        'proformaNumber': value.proformaNumber,
        'proformaId': value.proformaId,
        'matchesProforma': value.matchesProforma,
        'isPaid': value.isPaid,
        'status': value.status,
        'statusDescription': value.statusDescription,
        'eodChangeDate': value.eodChangeDate === undefined ? undefined : (value.eodChangeDate === null ? null : value.eodChangeDate.toISOString()),
        'pokChangeDate': value.pokChangeDate === undefined ? undefined : (value.pokChangeDate === null ? null : value.pokChangeDate.toISOString()),
        'filePath': value.filePath,
        'isTelevision': value.isTelevision,
        'isPostingChanged': value.isPostingChanged,
        'isAccountChanged': value.isAccountChanged,
        'cancelled': value.cancelled,
        'cancelledReason': value.cancelledReason,
        'paidStatus': value.paidStatus,
        'pesel': value.pesel,
    };
}

